import { FC } from 'react';

import type { ChatContextData } from '@eluve/api-contract';
import { Stack, Text } from '@eluve/components';

type ChatContextQuoteBlockProps = {
  context: ChatContextData;
};

export const ChatContextQuoteBlock: FC<ChatContextQuoteBlockProps> = ({
  context,
}) => (
  <Stack className="posthog-privacy-text rounded-lg border border-border-primary p-4">
    <Stack className="border-l-2 border-bg-tertiary pl-2">
      <Text
        size="sm"
        color="tertiary"
        weight="medium"
        className="whitespace-pre-wrap"
      >
        {context.text}
      </Text>
    </Stack>
  </Stack>
);
